import React, { useEffect } from 'react';
import { TriggerProps, useFaContent } from 'src/feature-app';
import { ProspectsPosventaForm, ProspectsVentaForm } from 'src/forms';

export function ProspectsActionTrigger({ setSelectedJourney }: TriggerProps): JSX.Element {
	const { action } = useFaContent();
	useEffect(() => {
		if (action === 'es-oneform--prospect-venta') setSelectedJourney(<ProspectsVentaForm />, true);
		else if (action === 'es-oneform--prospect-posventa') setSelectedJourney(<ProspectsPosventaForm />, true);
	}, []);

	return null;
}
